import { GrossProfitMarginValues, GrossProfitMarginResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateGrossProfitMargin(
  values: GrossProfitMarginValues, 
  t?: ToolsTranslations['grossProfitMargin']
): GrossProfitMarginResult {
  const { revenue, cogs } = values;

  // Add validation
  if (revenue < 0) return { 
    grossProfit: null, 
    marginPct: null, 
    isValid: false, 
    message: t?.invalid.revenue 
  };
  
  if (cogs < 0) return { 
    grossProfit: null, 
    marginPct: null, 
    isValid: false, 
    message: t?.invalid.cogs 
  };

  // Calculate gross profit
  const grossProfit = Math.round((revenue - cogs) * 100) / 100;
  
  // Calculate margin percentage
  let marginPct: number | null = null;
  if (revenue > 0) {
    marginPct = Math.round((grossProfit / revenue) * 10000) / 100; // Round to 2 decimals
  } else {
    // If revenue is 0, margin is undefined, but we'll show 0% with a message
    marginPct = 0;
  }

  // Check for invalid results
  if (!isFinite(grossProfit) || !isFinite(marginPct)) {
    return { 
      grossProfit: null, 
      marginPct: null, 
      isValid: false, 
      message: t?.invalid.generic 
    };
  }

  return { 
    grossProfit, 
    marginPct, 
    isValid: true 
  };
}
